import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { rem } from 'polished';

const modifierConfig = {
  error: ({ theme }) => `
    border-color: ${theme.palette.primary[1]};
  `,
  withIcon: () => `
    padding-left: 40px;
  `,
};

const Input = styled.input`
  width: 100%;
  height: 36px;
  box-sizing: border-box;
  font-size: ${rem('18px')};
  margin: 0;
  margin-top: 5px;
  padding-left: 0px;
  padding-bottom: 5px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px solid;
  border-color: ${(props) => props.theme.palette.border};
  transition: border-color ease 250ms;

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.palette.primary[0]};
  }

  &::placeholder {
    color: ${(props) => props.theme.palette.label};
    opacity: 1;
  }

  ${applyStyleModifiers(modifierConfig)};
`;

export default Input;
